const animations = {
  methods: {
    /**
     * Soft animation for changing the scroll position softy, only works with 'a' elements
     * @param {EventSource} event
     */
    anchorSoftAnimation (event) {
      let target = event.target.closest('a')
      try {
        if (location.pathname.replace(/^\//, '') === target.pathname.replace(/^\//, '') && location.hostname === target.hostname) {
          if (target.hash !== '') {
            let a = window.jQuery(target.hash)
            if ((a = a.length ? a : window.jQuery('[name="' + target.hash.slice(1) + '"]'))) {
              return window.jQuery('html, body').animate({
                scrollTop: a.offset().top - 56
              }, 1e3, 'easeInOutExpo')
            }
          } else {
            return window.jQuery('html, body').animate({
              scrollTop: -56
            }, 1e3, 'easeInOutExpo')
          }
        }
      } catch (error) {
        // eslint-disable-next-line
        console.error('Anchor Soft Animation Error', error)
      }
    }
  }
}

export default animations
